export default {
  accessToken: null,
  expiresIn: null,
  expiresFrom: null,
  hasCurrentActiveRequest: false
}



// WEBPACK FOOTER //
// ./src/modules/authorization/store/state.js